import { SET_COMPONENT_NAME } from '../actions';

export default (state = 'Default', action) => {
  switch (action.type) {
    case SET_COMPONENT_NAME:
      return action.componentName;
    default:
      return state;
  }
};
